var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.03,
    y: 0.03,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.83,5.99c-1.98,1.21-1.72,4.07.36,5.03-.11.27-.2.55-.33.81-.33.72-.76,1.37-1.3,1.94-.14.14-.29.28-.46.38-.35.22-.73.32-1.15.19-.21-.06-.42-.12-.62-.2-.74-.32-1.48-.32-2.22,0-.19.08-.39.14-.6.2-.48.14-.92.04-1.28-.28-.27-.23-.51-.49-.73-.76-.89-1.11-1.43-2.38-1.65-3.79-.17-1.04-.1-2.06.39-3.01.47-.91,1.19-1.5,2.2-1.72.54-.11,1.06-.02,1.57.17.21.08.41.15.62.23.3.12.59.11.89,0,.33-.13.66-.26,1-.35,1.2-.33,2.24-.02,3.11.86.05.05.1.12.14.18.03.04.04.08.07.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.55,1.65c.05.99-.33,1.78-1.04,2.42-.44.4-.95.6-1.55.53-.21-1.33,1.08-2.9,2.59-2.95Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApple);
export default __webpack_public_path__ + "static/media/logo-apple.beca8f84306e594fe135a3fe16277288.svg";
export { ForwardRef as ReactComponent };